"use client";

import { MotionConfig } from "framer-motion";

/**
 * Auth route-group layout.
 *
 * Wraps /login and /register in a Framer Motion config that honors the
 * user's `prefers-reduced-motion` setting. The global CSS kill-switch in
 * app/globals.css only reaches CSS animations/transitions — Framer drives
 * styles from rAF. This config handles transform/layout motion globally;
 * non-positional infinite loops such as opacity or background keyframes are
 * explicitly disabled with `useReducedMotion()` in the page components.
 * Mirrors the editor's `<MotionConfig reducedMotion="user">` in
 * loopcut-editor.tsx.
 */
export default function AuthLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return <MotionConfig reducedMotion="user">{children}</MotionConfig>;
}
